export default function PrimaryButton({ children, className = "", loading = false, loadingLabel = "", ...props }) {
    const explicitBusy = props["aria-busy"];
    const isBusy = Boolean(loading || explicitBusy === true || explicitBusy === "true");
    const buttonProps = {
        ...props,
        disabled: props.disabled || isBusy,
    };

    if (isBusy) {
        buttonProps["aria-busy"] = "true";
    } else if (buttonProps["aria-busy"] === false) {
        delete buttonProps["aria-busy"];
    }

    return (
        <button
            {...buttonProps}
            className={`
                auth-primary-button
                inline-flex items-center justify-center gap-2
                shadow-card 
                min-h-[56px] 
                w-full 
                duration-200 
                text-lg md:text-xl
                p-[12px_24px] 
                font-bold 
                text-surface 
                rounded-[44.85px]
                focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2
                disabled:cursor-not-allowed disabled:opacity-60
                ${className}
            `}
        >
            {isBusy ? <span className="auth-button-spinner" aria-hidden="true" /> : null}
            <span>{isBusy && loadingLabel ? loadingLabel : children}</span>
        </button>
    );
}
